import { useParams, useNavigate } from "react-router-dom";
import { BLOGS_DATA } from "./const";
import { Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import { Meta } from "@/components";

const SpecificBlog = () => {
  const { id } = useParams();

  const blog = BLOGS_DATA.find((b) => b.blogId === id);

  if (!blog) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-10">
        <h1 className="text-2xl font-bold">Blog not found</h1>
      </div>
    );
  }

  return (
    <>
      <Meta title={`Intron - ${blog.title}`} />
      <div className="bg-[#1F3342] text-white py-20 px-4 text-center">
        <nav aria-label="Breadcrumb" className="mb-4">
          <ol
            className="
        flex flex-wrap justify-center items-center 
        gap-2 
        text-base sm:text-lg 
        font-semibold
      "
          >
            <li>
              <Link to="/" className="text-primary hover:underline">
                Home
              </Link>
            </li>

            <li className="text-white">/</li>

            <li>
              <Link to="/blogs" className="text-primary hover:underline">
                Blogs
              </Link>
            </li>

            <li className="text-white">/</li>

            <li className="text-white font-bold max-w-[250px] sm:max-w-none text-center truncate sm:whitespace-normal">
              {blog.title}
            </li>
          </ol>
        </nav>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-10">
        {/* Heading */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {blog.title.split("®").map((part, index, arr) => (
            <React.Fragment key={index}>
              {part}
              {index !== arr.length - 1 && <sup>®</sup>}
            </React.Fragment>
          ))}
        </h1>

        {/* Intro */}
        <p className="text-gray-700 text-justify leading-relaxed mb-4">
          {blog.intro}
        </p>

        {/* Reasons */}
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
          {blog.reasons.map((reason, idx) => (
            <li key={idx}>
              <span className="font-semibold">{reason.label}</span> –{" "}
              {reason.text}
            </li>
          ))}
        </ul>

        {/* Subheading */}
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          {blog.subHeading}
        </h2>

        {/* Antibiotics Intro */}
        <p className="text-gray-700 text-justify leading-relaxed mb-4">
          {blog.antibioticsIntro}
        </p>

        {/* Antibiotics Bullet Points */}
        <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
          {blog.antibioticPoints.map((point, idx) => (
            <li key={idx}>{point}</li>
          ))}
        </ul>

        {/* Conclusion */}
        <p className="text-gray-700 text-justify leading-relaxed mb-6">
          {blog.conclusion}
        </p>

        {/* Highlighted Section */}
        <p className="text-gray-800 text-justify leading-relaxed font-medium mb-5">
          <span className="font-bold">CHECK®</span>{" "}
          {blog.highlightone.replace("CHECK®", "")}
        </p>

        <h3 className="text-gray-800 mb-4">
          CHECK® Works through a{" "}
          <span className="font-bold">multi-target approach, </span>
          ensuring quick and complete recovery:
        </h3>
        <ol className="list-decimal list-inside text-gray-700 space-y-2 mb-4 marker:font-bold">
          {blog.highlighttwo.multiTargetApproach.map((point, idx) => (
            <li key={idx}>{point}</li>
          ))}
        </ol>

        <p className="text-gray-700 mb-4 text-justify">
          {blog.highlighttwo.combinedAction}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mb-5">
          <div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">
              Benefits at a Glance
            </h4>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              {blog.highlighttwo.benefits.map((benefit, idx) => (
                <li key={idx}>{benefit}</li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold text-gray-900 mb-2">
              Dosage & Usage
            </h4>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              {blog.highlighttwo.dosage.map((dose, idx) => (
                <li key={idx}>{dose}</li>
              ))}
            </ul>
            <h4 className="text-lg font-semibold text-gray-900 mt-4 mb-2">
              Presentation
            </h4>
            <ul className="list-disc list-inside text-gray-700 text-justify space-y-1">
              {blog.highlighttwo.presentation.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
            <h4 className="text-lg font-semibold text-gray-900 mt-4 mb-2">
              Conclusion
            </h4>
            <ul className="list-disc list-inside text-gray-700 space-y-1 text-justify">
              {blog.highlighttwo.conclusion}
            </ul>
          </div>
        </div>
        <img
          src="/img/blogs/blog_1.png"
          alt={blog.title}
          className="w-full h-auto rounded-lg lg:mb-30 object-cover"
        />
      </div>
    </>
  );
};

export default SpecificBlog;
